import { getTag, useTranslation } from '@msdk/common'
import { useComponentModal } from '@msdk/forms'
import { IconSelector, Tooltip } from '@msdk/ui'
import { ManualsDownload } from 'components/ManualsDownload'
import { SidebarListItemButton } from 'components/Sidebar/SidebarItemButton'
import { SidebarListItemText } from 'components/Sidebar/SidebarItemText'
import { SidebarListItemIcon } from 'components/Sidebar/SidebarListItemIcon'
import { useNavigationMenu } from 'state/navigation-menu'

export function DocumentDownloadSection() {
  const { navigationMenuOpen, setNavigationMenu } = useNavigationMenu()
  const { createModal } = useComponentModal()
  const t = useTranslation()

  const handleClick = async () => {
    setNavigationMenu(navigationMenuOpen)
    const modalRef = createModal(<ManualsDownload />, () => {
      //
    })
    modalRef.open()
  }

  const handleOpenMenu = () => {
    setNavigationMenu(navigationMenuOpen)
  }

  const title = t('CMPSR_USR_MAN', 'User Manuals')

  if (navigationMenuOpen) {
    return (
      <SidebarListItemButton
        onClick={handleClick}
        key={crypto.randomUUID()}
        data-test-id={getTag('SHELL', 'SIDEMENU', 'USER_MANUALS', 'button')}
        level={0}
        last={true}
      >
        <SidebarListItemIcon>
          <IconSelector iconName="HelpOutline" />
        </SidebarListItemIcon>
        <SidebarListItemText>{title}</SidebarListItemText>
      </SidebarListItemButton>
    )
  }

  return (
    <Tooltip title={title} placement="right">
      <SidebarListItemButton
        onClick={handleOpenMenu}
        key={crypto.randomUUID()}
        data-test-id={getTag('SHELL', 'SIDEMENU', 'USER_MANUALS_CLOSED', 'button')}
        level={0}
        last={true}
      >
        <SidebarListItemIcon>
          <IconSelector iconName="HelpOutline" />
        </SidebarListItemIcon>
      </SidebarListItemButton>
    </Tooltip>
  )
}
